export default __webpack_public_path__ + "static/media/paymentMethodDPO.ef0daf73.png";